import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { GeneralService } from '../../../services/general.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { cellPhoneRequiredValidator } from 'src/app/directives/cellPhoneRequiredValidator';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    standalone: false
})
export class AddressComponent {

     form!: FormGroup;
     public wizard!: IWizard;
     userProfile?: UserProfile;
     _step = 5;

     get isReorder(): boolean {
          return this.userProfile?.userData?.roles.includes('driver') ?? false;
     }

     constructor (public service: DriverRecordRequestService,
          public generalService: GeneralService,
          public authenticationService: AuthenticationService,
          public _router: Router, private route: ActivatedRoute) {
          this.wizard = this.service.getWizard();
     }

     stateList: any = [];

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);

          this.userProfile = this.authenticationService.getUserProfile();

          if (this.service.isDriverRequestInitialized === false && this.service.loadFromLocal() === false) {
               this._router.navigateByUrl('/driver/1');
          }

          // Define inputs with validations 
          this.form = new FormGroup({
               addressLine1: new FormControl(this.service.driverRequest.address?.addressLine1, [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.pattern(/^([a-zA-Z0-9 '.\/]*)$/)
               ]),
               addressLine2: new FormControl(this.service.driverRequest.address?.addressLine2, [
                    Validators.maxLength(100),
                    Validators.pattern(/^([a-zA-Z0-9 '.\/]*)$/)
               ]),
               city: new FormControl(this.service.driverRequest.address?.city, [
                    Validators.required,
                    Validators.maxLength(30),
                    Validators.pattern(/^([a-zA-Z '\-\&amp;']*)$/)
               ]),
               state: new FormControl(this.service.driverRequest.address?.state, [
                    Validators.required
               ]),
               zip: new FormControl(this.service.driverRequest.address?.zip, [
                    Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(10),
                    Validators.pattern(/(^\d{5}(-\d{4})?$)/)
               ]),
               phoneNumber: new FormControl(this.service.driverRequest.address?.phoneNumber, [
                    Validators.required,
                    Validators.pattern(/^\d{10}$/)
               ]),
               altPhoneNumber: new FormControl(this.service.driverRequest.address?.altPhoneNumber, [
                    Validators.pattern(/^\d{10}$/)
               ]),
               // sendSmsMonitoringUpdates: new FormControl(this.service.driverRequest.sendSmsMonitoringUpdates) 
          }, { 
               validators: [
                    // cellPhoneRequiredValidator 
               ]
          });

          const statesPromise = this.generalService.getStatesByCountry('USA');
          statesPromise.then((v: any) => this.loadStates(v));
     }

     get addressLine1() { return this.form!.get('addressLine1'); }
     get addressLine2() { return this.form!.get('addressLine2'); }
     get city() { return this.form!.get('city'); }
     get state() { return this.form!.get('state'); }
     get zip() { return this.form!.get('zip'); }
     get phoneNumber() { return this.form!.get('phoneNumber'); }
     get altPhoneNumber() { return this.form!.get('altPhoneNumber'); }
     
     doTranslation(tag: string): string {
          return this.generalService.getTranslation(tag, 'driver');
     }

     ngOnDestroy() {
          this.service.driverRequest.address = {
               addressLine1: this.form.get('addressLine1')?.value,
               addressLine2: this.form.get('addressLine2')?.value,
               city: this.form.get('city')?.value,
               state: this.form.get('state')?.value,
               zip: this.form.get('zip')?.value,
               phoneNumber: this.form.get('phoneNumber')?.value,
               altPhoneNumber: this.form.get('altPhoneNumber')?.value,
               countryId: 1,
               country: 'US'
          };

          this.service.saveToLocal();
     }

     loadStates(value: string[]) {
          this.stateList = value;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }

     getStepForPercentComplete() {
          if (this.service.isReorder()) {
               return 2;
          } else {
               return this._step;
          }
     }
}
